// External
import React from "react"
import { useTranslation } from "react-i18next"

// Internal
import useIsWide from "../../utils/use-is-wide"
import useStyles from "../styles"
import ContractsSelector from "../contracts-selector"
import normalizeCompilerVersion from "../../utils/normalize-compiler-versions"
import { Select } from "../select"
import store from "src/store"

//@ts-check
/** @param props{{
 * files:scr.file[]
 * mainFile:string
 * mainContract:string
 * setMainContract:(contract:string)=>void
 * setMainFile:(file:string)=>void
 * setCompilerVersion:(compilerVersion) => void
 * compilerVersion: string
 * CTA:JSX.Element
 * compileErrors
 * simplifier
 * lowerVersionError?
 * }}
 */
export default function ScanSection({
  files,
  mainFile,
  mainContract,
  setMainContract,
  setMainFile,
  setCompilerVersion,
  compilerVersion,
  CTA,
  compileErrors,
  simplifier,
  lowerVersionError,
}) {
  const classes = useStyles({})
  const { t } = useTranslation()
  let isShowContractSelector = useIsWide()
  return (
    <div className={classes.initiateScanSection} id="scan-section">
      <div className={classes.selectContractAndScan}>
        {isShowContractSelector && (
          <div className={classes.contractSelector}>
            <ContractsSelector
              files={files}
              mainFile={mainFile}
              mainContract={mainContract}
              setMainContract={setMainContract}
              setMainFile={setMainFile}
            />
          </div>
        )}
        {CTA}
      </div>
      <Select
        value={compilerVersion}
        onChange={e => setCompilerVersion(e.target.value)}
        error={lowerVersionError}
      >
        {store.solidityCompilerVersions.map(version => (
          <option key={version} value={version}>
            {normalizeCompilerVersion(version)}
          </option>
        ))}
      </Select>
    </div>
  )
}
